// DGII's buyer-identification rules (same as backend/utils/buyerId.js — keep the two in step): a Crédito Fiscal (E31)
// always needs the client's RNC (9 digits) or cédula (11); a Consumidor Final (E32) needs it from RD$250,000 total.
const E32_ID_THRESHOLD = 250000;
const buyerIdDigits = (client) => String(client?.rnc || client?.cedula || '').replace(/\D/g, '');
export const hasValidBuyerId = (client) => [9, 11].includes(buyerIdDigits(client).length);

export function buyerIdProblem(tipoEcf, client, total) {
  if (!client || hasValidBuyerId(client)) return null;
  if (tipoEcf === 'E31') return 'Una factura de Crédito Fiscal (E31) necesita el RNC o la cédula del cliente. Agrégalo en Clientes, o usa Consumidor Final (E32).';
  if (tipoEcf === 'E32' && Number(total) >= E32_ID_THRESHOLD) return 'DGII exige identificar al comprador en una factura de Consumidor Final de RD$250,000 o más: agrega el RNC o la cédula del cliente en Clientes.';
  return null;
}
